import UploadContext from 'FeatureModules/Document/Contexts/UploadContext';
import { useContext } from 'react';
import { IBaseDocument } from 'FeatureModules/Document/types/document.types';

type TAdditionalProperties = {
  formikName: string;
};

type TFileMap = {
  [id: string]: {
    recordId: string;
    data: File;
    error?: string;
    success: boolean;
    uploadStarted: boolean;
    uploadTask: unknown;
    itemType: string;
    progress?: number;
    contextObject: TAdditionalProperties;
  };
};

// Not 100% sure about these types, but don't have time to type the full context atm
interface IReturnProps {
  cleanFiles: () => void;
  addFiles: (fileIDs: string[]) => void;
  removeFile: (id: string, isRecordId?: boolean) => void;
  fileMap: TFileMap;
  fileIDs: string[];
  createdRecords: IBaseDocument[];
  handleCleanCreatedRecords: () => void;
  updateRecordsFromCache: () => void;
  undoFileUploads: () => void;
}

const useUploadState = () => {
  const values: IReturnProps = useContext(UploadContext);
  return values;
};

export default useUploadState;
